import React, { useState } from "react"

import {
  validateFaxNumberOnlyDigit,
  customSelectStyles,
  prepareFinalFaxNumberForPhonebook,
} from "../../utils/common"

import { FaxNumberToolTip } from "./../common/faxNumberToolTip"

import Select from "react-select"

const PhonebookModal = ({
  onClose,
  onSave,
  actionLoading,
  queueLevelData,
  phonebookToEdit,
  fromInOutBound = null,
}) => {
  const [firstName, setFirstName] = useState(phonebookToEdit?.firstName)
  const [lastName, setLastName] = useState(phonebookToEdit?.lastName)
  const [faxNumber, setFaxNumber] = useState(
    phonebookToEdit?.faxNumber || fromInOutBound?.faxNumber
  )
  const [emailAddress, setEmail] = useState(phonebookToEdit?.emailAddress)
  const [company, setCompany] = useState(phonebookToEdit?.company)
  const [type, setType] = useState(
    phonebookToEdit?.type || fromInOutBound?.type || "PERSONAL"
  )
  const [queue, setQueue] = useState(phonebookToEdit?.queue)
  const [errorMessage, setErrorMessage] = useState("")
  const [isUpdatedState, setIsUpdatedState] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!faxNumber) {
      setErrorMessage("Fax Number is required.")
      return
    } else {
      const errorMsg = validateFaxNumberOnlyDigit(faxNumber.trim())
      if (errorMsg) {
        setErrorMessage(errorMsg)
        return
      }
    }

    if (!firstName) {
      setErrorMessage("First Name is required.")
      return
    }

    if (!lastName) {
      setErrorMessage("Last Name is required.")
      return
    }

    if (emailAddress) {
      //if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddress)) {
      if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailAddress)
      ) {
        setErrorMessage("Email Address is incorrect.")
        return
      }
    }

    if (type === "QUEUE" && !queue) {
      setErrorMessage("Queue is required.")
      return
    }

    const phonebookData = {
      firstName,
      lastName,
      faxNumber: prepareFinalFaxNumberForPhonebook(faxNumber),
      emailAddress,
      company,
      queue: type === "QUEUE" ? queue : "",
      type,
      oldFaxNumber: phonebookToEdit?.faxNumber,
      oldQueue: phonebookToEdit?.queue,
    }

    onSave(phonebookData)
  }

  const optionQueues = queueLevelData
    .map((n) => ({ value: n.queue, label: n.queue }))
    .sort((a, b) => a.value.localeCompare(b.value))

  return (
    <>
      <div className="popup-overlay">
        <div className="popup">
          {actionLoading ? (
            <div style={{ padding: "20px" }}>In progress ...</div>
          ) : (
            <div>
              <div className="checkbox-popup-header">
                {/* <h3>{phonebook ? "Edit Phonebook" : "Add New Phonebook"}</h3> */}

                <h3 className="popup-title">
                  {phonebookToEdit ? `Update` : `Add`} Phonebook
                </h3>
                <button
                  type="button"
                  onClick={onClose}
                  style={{
                    background: "transparent",
                    border: "none",
                    fontSize: 24,
                    cursor: "pointer",
                  }}
                >
                  ×
                </button>
              </div>

              <form className="popup-group" onSubmit={handleSubmit}>
                {!phonebookToEdit && (
                  <div className="form-group">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "1rem",
                      }}
                    >
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.25rem",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          value="PERSONAL"
                          checked={type === "PERSONAL"}
                          onChange={() => {
                            setType("PERSONAL")
                            setErrorMessage("")
                          }}
                          style={{
                            cursor: "pointer",
                          }}
                        />
                        Personal
                      </label>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.25rem",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          value="QUEUE"
                          checked={type === "QUEUE"}
                          onChange={() => {
                            setType("QUEUE")
                            setErrorMessage("")
                          }}
                          style={{
                            cursor: "pointer",
                          }}
                        />
                        Queue
                      </label>
                    </div>
                    <span style={{ fontSize: "12px" }}>
                      Choose Personal for private entries, or Queue to create a
                      shared/queue-level entry.
                    </span>
                  </div>
                )}
                <div className="form-group">
                  <label htmlFor="firstName">
                    First Name: <span className="mandatory">*</span>
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    value={firstName}
                    maxLength={50}
                    onChange={(e) => {
                      setFirstName(e.target.value)
                      setErrorMessage("")
                      if (!isUpdatedState) setIsUpdatedState(true)
                    }}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">
                    Last Name: <span className="mandatory">*</span>
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    value={lastName}
                    maxLength={50}
                    onChange={(e) => {
                      setLastName(e.target.value)
                      setErrorMessage("")
                      if (!isUpdatedState) setIsUpdatedState(true)
                    }}
                  />
                </div>
                {type === "QUEUE" && (
                  <div className="form-group">
                    <label htmlFor="queue">
                      Queue: <span className="mandatory">*</span>
                    </label>
                    <Select
                      id="queue"
                      className="basic-single"
                      classNamePrefix="select"
                      value={optionQueues.find(
                        (option) => option.value === queue
                      )}
                      onChange={(selectedOption) => {
                        setQueue(selectedOption.value)
                        if (!isUpdatedState) setIsUpdatedState(true)
                      }}
                      options={optionQueues}
                      styles={customSelectStyles}
                      isSearchable
                      menuPortalTarget={document.body}
                    />
                  </div>
                )}
                <div className="form-group">
                  <label htmlFor="faxNumber">
                    Fax Number: <span className="mandatory">*</span>{" "}
                    <FaxNumberToolTip />
                  </label>
                  <input
                    type="text"
                    id="faxNumber"
                    value={faxNumber}
                    //maxLength={11}
                    onChange={(e) => {
                      //const onlyDigits = e.target.value.replace(/\D/g, "")
                      setFaxNumber(e.target.value)
                      setErrorMessage("")
                      if (!isUpdatedState) setIsUpdatedState(true)
                    }}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="emailAddress">Email Address:</label>
                  <input
                    type="emailAddress"
                    id="emailAddress"
                    value={emailAddress}
                    onChange={(e) => {
                      setEmail(e.target.value)
                      setErrorMessage("")
                      if (!isUpdatedState) setIsUpdatedState(true)
                    }}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="company">
                    Company:
                    {/* <span className="mandatory">*</span> */}
                  </label>
                  <input
                    type="text"
                    id="company"
                    value={company}
                    maxLength={50}
                    onChange={(e) => {
                      setCompany(e.target.value)
                      setErrorMessage("")
                      if (!isUpdatedState) setIsUpdatedState(true)
                    }}
                  />
                </div>
                {errorMessage && (
                  <div className="error-message">{errorMessage}</div>
                )}
                <div className="popup-buttons">
                  <button
                    type="button"
                    className="popup-buttons cancel"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="popup-buttons save"
                    disabled={!isUpdatedState}
                  >
                    {phonebookToEdit ? "Update" : "Save"}
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default PhonebookModal
